import { render, staticRenderFns } from "./newsTab.vue?vue&type=template&id=0ffd7310&scoped=true&lang=pug"
import script from "./newsTab.vue?vue&type=script&lang=js"
export * from "./newsTab.vue?vue&type=script&lang=js"
import style0 from "./newsTab.vue?vue&type=style&index=0&id=0ffd7310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffd7310",
  null
  
)

export default component.exports